import React, { Component } from "react";
import PropTypes from "prop-types";

// styles
import "./background.scss";

class BackgroundWithLines extends Component {
  constructor(props) {
    super(props);
    this.resizeTimer = null;
    this.state = {
      windowWidth: null,
      linesActive: true,
    };
    this.resizeHandler = this.resizeHandler.bind(this);
    this.setPageWidth = this.setPageWidth.bind(this);
    this.toggleLines = this.toggleLines.bind(this);
  }

  componentDidMount() {
    this.setPageWidth();
    window.addEventListener("resize", this.resizeHandler);
    window.addEventListener("keydown", event => this.toggleLines(event));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeHandler);
    window.removeEventListener("keydown", event => this.toggleLines(event));
  }

  resizeHandler() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.setPageWidth();
    }, 350);
  }
  
  toggleLines(event) {
    if (event.keyCode === 76 && event.ctrlKey) {
      this.setState(prevState => ({linesActive: !prevState.linesActive}));
    }
  }

  setPageWidth() {
    const currentScreenSize = window.innerWidth;
  
    if (typeof window === 'undefined' || currentScreenSize < 1475) {
      this.setState({
        windowWidth: null
      });
      
      return false;
    }
    
    const lowest = 20;
    const highest = 180;
    const minScreen = 320;
    const maxScreen = 1280;

    const rawPadding =
      lowest +
      (highest - lowest) *
        ((currentScreenSize - minScreen) / (maxScreen - minScreen));
    const currentPadding = Math.max(lowest, Math.min(highest, rawPadding));

    const desktopSectionWidth =
      (Math.max(900, Math.min(1600, document.body.clientWidth)) -
        currentPadding * 2) /
      6;

    this.setState({
      windowWidth: desktopSectionWidth
    });
  }

  renderLineSection() {
    const numberOfSections = this.state.windowWidth ?
      2 *
      Math.round(
        Math.ceil(
          (typeof window === "undefined" ? 1280 : window.innerWidth) /
            this.state.windowWidth
        ) / 2
      )
     : 8;
    
    const sectionsArray = [];

    for (let i = 0; i < numberOfSections; i++) {
      sectionsArray.push(
        <div
          key={`section-${i}`}
          className={`line-section ${
            this.props.theme === "white" ? "-white" : ""
          }`}
          style={{ width: this.state.windowWidth ? this.state.windowWidth + "px" : '' }}
        />
      );
    }

    return sectionsArray;
  }

  render() {
    const lines = this.renderLineSection();
    if (this.props.children) {
      return (
        <div className="background-with-lines" style={{ position: "relative" }}>
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              overflow: "hidden"
            }}
          >
            <div
              className={`line-container -content ${
                this.props.theme === "white" ? "-white" : ""
              } ${
                this.state.linesActive ? '' : '-disabled'
                }`}
            >
              {lines}
            </div>
          </div>
          <div style={{ position: "relative"}}>
          {/* <div style={{ position: "relative", zIndex: 1 }}> */}
            {this.props.children}
          </div>
        </div>
      );
    }

    return (
      <div
        className={`line-container ${
          this.props.theme === "white" ? "-white" : ""
        } ${
          this.state.linesActive ? '' : '-disabled'
          }`}
      >
        {lines}
      </div>
    );
  }
}

BackgroundWithLines.defaultProps = {
  theme: "blue",
};

BackgroundWithLines.propTypes = {
  theme: PropTypes.string,
};

export default BackgroundWithLines;
